import { useTranslation } from 'react-i18next';
import { Form, FormActions, message } from 'ui';
import { useUser } from 'features/auth';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { useUpdateUserProfileMutation } from 'features/users/queries';
import { UserTranslationsFormContent, type UserTranslationsFormValues } from './user-translations-form-content';

const UserTranslationsForm = () => {
  const { isPending: isLoading, mutate: updateProfile } = useUpdateUserProfileMutation();

  const { railsUserData: viewer } = useUser();

  const {
    // eslint-disable-next-line @typescript-eslint/unbound-method -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
    i18n: { changeLanguage, language },
  } = useTranslation();

  const initialValues =
    viewer.settings.translations.enableTranslations.value && 'language' in viewer.settings.translations
      ? {
          enableTranslations: true,
          language,
          translationLanguage: { value: viewer.settings.translations.language.value },
        }
      : {
          enableTranslations: false,
          language,
        };

  const onFinish = async (values: UserTranslationsFormValues) => {
    await changeLanguage(values.language);

    updateProfile(
      {
        userData: {
          settings: {
            translations: values.enableTranslations
              ? {
                  enableTranslations: values.enableTranslations,
                  language: values.translationLanguage.value,
                }
              : {
                  enableTranslations: values.enableTranslations,
                },
          },
        },
        userId: viewer.id,
      },
      {
        onSuccess() {
          message.success('Language updated successfully');
        },
      },
    );
  };

  return (
    <Form<UserTranslationsFormValues> initialValues={initialValues} onFinish={onFinish}>
      <UserTranslationsFormContent<UserTranslationsFormValues> />
      <FormActions
        layout="start"
        submit={{
          children: 'Save',
          loading: isLoading,
        }}
      />
    </Form>
  );
};

export default UserTranslationsForm;
